import React from 'react';

import classNames from 'classnames';

/**
 * A figure above its label on a filled tile. An attention tile is amber with
 * a start border.
 */
export default function StatFigureTile({ value, label, attention = false }) {
    return (
        <div
            className={classNames('tw-px-4 tw-py-3 tw-rounded-lg', {
                'tw-bg-charcoal-10': !attention,
                'tw-bg-amber-50 tw-border-s-4 tw-border-amber-400': attention,
            })}
        >
            <div className={classNames('tw-text-2.5xl tw-font-semibold', attention ? 'tw-text-amber-700' : 'tw-text-blue')}>{value ?? '—'}</div>
            <div className="tw-text-xs tw-text-charcoal-75 tw-mt-1">{label}</div>
        </div>
    );
}
